import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WebhookMacro, WebhookParameter} from '../../../../core/models/webhook';


@Component({
  selector: 'app-webhook-parametertable',
  templateUrl: './webhook-parametertable.component.html'
})
export class WebhookParametertableComponent implements OnInit {

  constructor() {
  }

  @Output() changed: EventEmitter<WebhookParameter[]> = new EventEmitter<WebhookParameter[]>();
  @Input() webRequestParameters: WebhookParameter[];
  @Input() macros: WebhookMacro[];
  newParameter: WebhookParameter;
  @Input() disabled: boolean;

  ngOnInit() {
    if (this.webRequestParameters === undefined)  {
      this.webRequestParameters = new Array();
    }
    this.init();
  }

  init() {
    this.newParameter = undefined;
  }

  addNewParameter() {
    this.newParameter = new WebhookParameter();
  }

  deleteNewParameter() {
    this.init();
  }

  saveNewParameter() {
    this.webRequestParameters.push(this.newParameter);
    this.changed.emit(this.webRequestParameters);
    this.init();
  }

  deleteParameter(webRequestParameter: WebhookParameter) {
    this.webRequestParameters = this.webRequestParameters.filter(parameter => parameter !== webRequestParameter);
    this.changed.emit(this.webRequestParameters);
  }

  getMacros() {
    let macroList = "";
    this.macros.forEach(macro => macroList = macroList + "\n" + macro.macroValue);
    return macroList;
  }

}

